import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  components: {
    pie3d: function pie3d() {
      return import('@/components/pie3d');
    },
    m3u8Video: function m3u8Video() {
      return import('@/components/m3u8Video');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      showVideoId: '',
      log_list: [{}, {}],
      list: [{
        name: '池1',
        typeCode: 'item_db'
      }, {
        name: '池2',
        typeCode: 'item_dc'
      }, {
        name: '池3',
        typeCode: 'item_dd'
      }, {
        name: '池4',
        typeCode: 'item_de'
      }, {
        name: '池5',
        typeCode: 'item_df'
      }, {
        name: '池6',
        typeCode: 'item_dg'
      }, {
        name: '池7',
        typeCode: 'item_dh'
      }, {
        name: '池8',
        typeCode: 'item_di'
      }],
      lastData: {},
      items: {},
      dataList: [],
      total: 0
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$api['smartControlQuery']({
                labId: localStorage.getItem('labId'),
                type: 'SC_Feeder',
                page: 1,
                limit: 10
              });
            case 2:
              res = _context.sent;
              _this.fdrDeviceId = res.data[0].id;
              _this.showVideoId = res.data[0].showVideoId;
              _context.next = 7;
              return _this.getItems();
            case 7:
              _context.next = 9;
              return _this.getLogs();
            case 9:
              _context.next = 11;
              return _this.getLast();
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getItems: function getItems() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _iterator, _step, item;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$api['smartControlItemQuery']({
                page: 1,
                limit: -1,
                smartControlId: _this2.fdrDeviceId,
                sortField: '^sort'
              });
            case 2:
              res = _context2.sent;
              _iterator = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  _this2.$set(_this2.items, item.typeCode, item);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getLogs: function getLogs() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.$api['smartControlTLogSamplesDays'](_this3.fdrDeviceId, dayjs().subtract(1, 'day').unix(), dayjs().unix());
            case 2:
              res = _context3.sent;
              _this3.log_list = res.data || [];
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getLast: function getLast() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res, colorPalette, _iterator2, _step2, item;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.$api['smartControlLastRecord'](_this4.fdrDeviceId);
            case 2:
              res = _context4.sent;
              _this4.lastData = res.data || {};
              _this4.dataList = [];
              _this4.total = res.data.item_dj - 0;
              colorPalette = ['#48E5C7', '#FF6B6B', '#FFD93D', '#6BCBFF', '#A66CFF'];
              _iterator2 = _createForOfIteratorHelper(_this4.list);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  item = _step2.value;
                  _this4.dataList.push({
                    name: item.name,
                    val: Number(res.data[item.typeCode]),
                    itemStyle: {
                      color: colorPalette[_this4.dataList.length % colorPalette.length]
                    }
                  });
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              console.log('this.dataList', _this4.dataList);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    backClick: function backClick() {
      this.$router.back();
    }
  }
};